import { allFonts, FontCategory } from '@quicktools/shared-components/data/fonts';

import storage from '../../utils/common/localStorage';

export default function getFontsByCategory(selectedCategory: FontCategory) {
  const fontsList = Object.values(allFonts);

  switch (selectedCategory) {
    case FontCategory.Recents: {
      const fontIds = storage.getValue();

      return fontIds.map((id) => allFonts[id]).filter((f) => Boolean(f));
    }
    case FontCategory.All: {
      return fontsList;
    }
    default: {
      return fontsList.filter((f) => f.categories.includes(selectedCategory));
    }
  }
}
